import { Flex, SimpleGrid } from "@chakra-ui/react";
import ButtonComp from "components/Button";
import { Header } from "components/Header";
import InputComp from "components/InputComp";
import TableList from "components/TableList";
import { toaster } from "components/ui/toaster";
import constant from "constant";
import useCheckMobileScreen from "hooks/useCheckMobileScreen";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "services/api";
import utils from "utils";

const headers = [
  "Sells",
  "Agreement",
  {
    label: "Price",
    colW: "12ch",
    style: {
      textAlign: "end",
    },
  },
  "Refund",
  "Admin",
  "%",
  {
    label: "£",
    colW: "12ch",
    style: {
      textAlign: "end",
    },
  },
];

const genTbTxtGreen = (label) => ({
  label: label,
  cellStyle: {
    color: "textv2.green2",
    fontWeight: "bold",
  },
});

const formatAmountForTb2 = (amt) =>
  utils.formatAmountForTb(amt, "", genTbTxtGreen().cellStyle);

// const updateListF = (arr) => {
//   if (arr && arr[0]) {
//     return arr?.map((a) => {
//       a.Sells = genTbTxtGreen("Yes");
//       return a;
//     });
//   }
// };

// const items = [
//   {
//     id: 1,
//     sell: "Sells",
//     ag: "Agreement",
//     pr: "Price",
//     ref: "Refund",
//     admin: "Admin",
//     per: "%",
//     amt: "£",
//   },
// ];

function PricingView() {
  const [isLoading, setIsLoading] = useState(false);
  const [list, setList] = useState([]);
  const [selectedItem, setSelectedItem] = useState();
  // const [activePage, setActivePage] = useState(1);
  // const [searchTxt, setSearchTxt] = useState("");
  // const [searchLoading, setSearchLoading] = useState(false);

  const [newprice, setNewprice] = useState();

  // AU Admin Charge
  const [adminchargeDD, setAdminchargeDD] = useState();
  const [adminchargeItem, setAdminchargeItem] = useState();
  const [adminChargeAmount, setAdminChargeAmount] = useState();
  const [adminChargePer, setAdminChargePer] = useState();

  const [refundDD, setRefundDD] = useState();
  const [refundItem, setRrefundItem] = useState();

  const ismobile = useCheckMobileScreen();
  const navigate = useNavigate();
  const location = useLocation();

  // const action = location.state?.action;
  const itemData = location.state?.data;

  const resetIp = () => {
    setRrefundItem();
    setAdminchargeItem();
    setNewprice(0);
    setAdminChargePer();
    setAdminChargeAmount();

    getRefundDD();
    getChangeAdminchargeDD();
  };

  const getpoladminData = ({
    poladmincosttype,
    poladmincostcent,
    poladmincostamt,
  }) => {
    // data?.item?.data?.pricingexceptiodata?.poladmincosttype
    let poladmincostcent2 = 0;
    let poladmincostamt2 = 0;

    if (poladmincosttype === 1) {
      poladmincostcent2 = poladmincostcent;
      poladmincostamt2 = 0;
    } else if (poladmincosttype === 2) {
      poladmincostcent2 = 0;
      poladmincostamt2 = poladmincostamt;
    }

    return {
      poladmincostcent: poladmincostcent2,
      poladmincostamt: poladmincostamt2,
    };
  };

  const onSubmit = async () => {
    const pl = {};
    pl.dealerid = itemData?.item?.data?.userid;
    pl.pricingexception_data = [];

    const list2 = JSON.parse(JSON.stringify(list || []));
    if (list2 && list2[0]) {
      list2.forEach((a) => {
        if (a?.Sells?.label === "Yes") {
          const poladminData = getpoladminData({
            poladmincosttype: a?.data?.pricingexceptiodata?.poladmincosttype,
            poladmincostcent: a?.data?.pricingexceptiodata?.poladmincostcent,
            poladmincostamt: a?.data?.pricingexceptiodata?.poladmincostamt,
          });

          pl.pricingexception_data.push({
            pricingid: a?.data?.id,
            newprice: a?.data?.pricingexceptiodata?.newprice,
            refundid: a?.data?.pricingexceptiodata?.refundid,
            poladmincosttype: a?.data?.pricingexceptiodata?.poladmincosttype,
            poladmincostcent: poladminData?.poladmincostcent,
            poladmincostamt: poladminData?.poladmincostamt,
            exceptionrefundtype:
              a?.data?.pricingexceptiodata?.exceptionrefundtype,
            exceptionrefundvalue:
              a?.data?.pricingexceptiodata?.exceptionrefundvalue,
            exceptionrefundduration:
              a?.data?.pricingexceptiodata?.exceptionrefundduration,
          });
        }
      });
    }

    setIsLoading(true);
    const res = await api.updatePricingexception(pl);
    setIsLoading(false);
    console.log("updatePricingexception res ", res);
    toaster.create({
      title: res?.response?.data?.message || res?.data?.message || res?.message,
      type: res?.status === 200 ? "success" : "error",
    });

    if (res?.status === 200) {
      navigate("/Pricing", {
        state: {},
      });
    }
    return res;
  };

  const onUpdate = ({ data }) => {
    console.log("onUpdate", { refundItem, adminchargeItem });

    const list2 = JSON.parse(JSON.stringify(list || []));

    if (
      list2 &&
      list2[selectedItem?.index]?.data &&
      list2[selectedItem?.index]?.Sells?.label === "Yes"
    ) {
      // if (newprice <= 0) {
      //   list2[selectedItem?.index] = {
      //     ...list2[selectedItem?.index],
      //     Refund: "",
      //     Admin: "",
      //     Price: "",
      //     "%": "",
      //     "£": "",
      //     Sells: "",
      //     data: {
      //       ...list2[selectedItem?.index]?.data,
      //       pricingexceptiodata: undefined,
      //     },
      //   };
      // } else {

      const poladminData = getpoladminData({
        poladmincosttype: adminchargeItem?.id,
        poladmincostcent: adminChargePer,
        poladmincostamt: adminChargeAmount,
      });

      list2[selectedItem?.index] = {
        ...list2[selectedItem?.index],
        Refund: genTbTxtGreen(refundItem?.label || " "),
        Admin: genTbTxtGreen(adminchargeItem?.label || " "),
        Price: formatAmountForTb2(newprice),
        "%": genTbTxtGreen(poladminData.poladmincostcent || " "),
        "£": poladminData.poladmincostamt
          ? formatAmountForTb2(poladminData.poladmincostamt)
          : "",
        Sells: genTbTxtGreen("Yes"),
        data: {
          ...list2[selectedItem?.index]?.data,
          pricingexceptiodata: {
            ...list2[selectedItem?.index]?.data?.pricingexceptiodata,
            poladmincosttype: adminchargeItem?.id || "",
            refundid: refundItem?.refundid || "",
            newprice: newprice,
            poladmincostcent: poladminData.poladmincostcent || "",
            poladmincostamt: poladminData.poladmincostamt || "",
          },
        },
      };
      // }

      /*

      // 1
      list2[selectedItem?.index].data.pricingexceptiodata.refundid =
        refundItem?.refundid;
      list2[selectedItem?.index].Refund = refundItem?.label || "";

      // 2
      list2[selectedItem?.index].data.pricingexceptiodata.poladmincosttype =
        adminchargeItem?.id;
      list2[selectedItem?.index].Admin = adminchargeItem?.label || "";

      // 3
      list2[selectedItem?.index].Price = newprice || "";
      list2[selectedItem?.index]["%"] = adminChargePer || "";
      list2[selectedItem?.index]["£"] = adminChargeAmount || "";

      list2[selectedItem?.index].Sells = "Yes";
      */
      setList(list2);
      resetIp();
    }
    setSelectedItem();
  };

  const getPricingexception = async () => {
    setIsLoading(true);
    const res = await api.getPricingexception({
      dealerid: itemData?.item?.data?.userid,
    });
    setIsLoading(false);
    if (res?.status === 200) {
      console.log("getPricingexception res ", res.data);
    } else {
      toaster.create({
        title: res?.message || "error",
        type: "error",
      });
    }
    return res;
  };

  const onChangeRefundDD = (data) => {
    console.log("onChangeRefundDD", data);
    setRefundDD(data?.list ? [...data.list] : []);
    // setRrefundid(data?.item?.data?.label);
    setRrefundItem(data?.item?.data);

    // if (data && data?.action === undefined) {
    //   const list2 = JSON.parse(JSON.stringify(list || []));

    //   if (list2[selectedItem?.index].data) {
    //     list2[selectedItem?.index].data.pricingexceptiodata.refundid =
    //       data?.item?.data?.refundid;

    //     list2[selectedItem?.index].Refund = data?.item?.data?.label;
    //   }
    //   // list2?.map((a) => {})
    //   setList(list2);
    // }
  };

  const getRefundDD = (data) => {
    let index;
    let list;
    let item;
    let action = data?.action || "any";

    list = constant.refundDD?.map((a, inx) => ({
      key: `refund-${inx}`,
      value: `${a?.label}-${inx}`,
      label: `${a?.label}`,
      data: a,
    }));

    if ((data?.default || data?.default === 0) && list && list[0]) {
      list = list?.map((a, idx) => {
        if (a?.data?.refundid === data.default) {
          a.selected = true;
          item = a;
          index = idx;
        }
        return a;
      });
      action = "default";
    }

    onChangeRefundDD({
      index,
      list,
      item,
      action,
    });
  };

  const onChangeAdminchargeDD = (data) => {
    setAdminchargeDD(data?.list ? [...data.list] : []);
    setAdminchargeItem(data?.item?.data);

    // if (data && data?.action === undefined) {
    //   const list2 = JSON.parse(JSON.stringify(list || []));

    //   if (list2[selectedItem?.index].data) {
    //     list2[selectedItem?.index].data.pricingexceptiodata.poladmincosttype =
    //       data?.item?.data?.poladmincosttype;

    //     list2[selectedItem?.index].Admin = data?.item?.data?.label;
    //   }
    //   setList(list2);
    // }
  };

  const getChangeAdminchargeDD = (data) => {
    let index;
    let list;
    let item;
    let action = data?.action || "any";

    list = constant.auAdminChargesDD?.map((a, inx) => ({
      key: `admincharge-${inx}`,
      value: `${a?.label}-${inx}`,
      label: `${a?.label}`,
      data: a,
    }));

    if ((data?.default || data?.default === 0) && list && list[0]) {
      list = list?.map((a, idx) => {
        if (a?.data?.id === data.default) {
          a.selected = true;
          item = a;
          index = idx;
        }
        return a;
      });

      action = "default";
    }

    onChangeAdminchargeDD({
      index,
      list,
      item,
      action,
    });
  };

  const onSelect = (data) => {
    const list2 = JSON.parse(JSON.stringify(list || []));

    setSelectedItem(data);
    console.log("onSelect", data);

    //data?.item?.data?.id

    if (
      data?.item?.Sells?.label === "Yes" &&
      selectedItem?.index === data?.index
    ) {
      resetIp();
      if (list2 && list2[data?.index]?.data) {
        list2[data?.index] = {
          ...list2[data?.index],
          Refund: "",
          Admin: "",
          Price: "",
          "%": "",
          "£": "",
          Sells: "",
          data: {
            ...list2[data?.index]?.data,
            pricingexceptiodata: undefined,
          },
        };
        setList(list2);
      }
    } else {
      if (list2 && list2[data?.index]) {
        list2[data?.index].Sells = genTbTxtGreen("Yes");
      }

      setList(list2);

      getRefundDD({ default: data?.item?.data?.pricingexceptiodata?.refundid });
      getChangeAdminchargeDD({
        default: data?.item?.data?.pricingexceptiodata?.poladmincosttype,
      });
      setNewprice(data?.item?.data?.pricingexceptiodata?.newprice || 0);

      const poladminData = getpoladminData({
        poladmincosttype:
          data?.item?.data?.pricingexceptiodata?.poladmincosttype,
        poladmincostcent:
          data?.item?.data?.pricingexceptiodata?.poladmincostcent,
        poladmincostamt: data?.item?.data?.pricingexceptiodata?.poladmincostamt,
      });
      setAdminChargePer(poladminData.poladmincostcent);
      setAdminChargeAmount(poladminData.poladmincostamt);
    }
  };

  const getList = async () => {
    setIsLoading(true);
    api.getPricing().then((res) => {
      setIsLoading(false);
      if (res?.status === 200) {
        console.log("getPricing res ", res.data);

        let l = [];
        if (res?.data && res?.data[0]?.id) {
          res.data.forEach((item, index) => {
            let label = "";

            if (item?.covername) {
              label += item?.covername;
              label += " ";
            }

            if (item?.durationvalue) {
              label += item?.durationvalue;
              label += " ";
            }

            if (item?.durationtype) {
              label += item?.durationtype;
              label += " ";
            }

            if (item?.purchaselimitamount) {
              label += "Claim ";
              label += item?.purchaselimitamount;
              label += " ";
            }

            label += "\n";
            label += `= ${utils.formatCurrency(item?.price || 0)}`;
            label += "\n";

            l.push({
              id: `item-${index}-1`,
              Sells: "",
              Agreement: label || "",
              Price: "",
              Refund: "",
              Admin: "",
              "%": " ",
              "£": "",
              data: item,
            });

            // l.push({
            //   id: `item-${index}-2`,
            //   Sells: "",
            //   Agreement: `= ${utils.formatCurrency(
            //     item?.pricingrefundvalue || 0
            //   )}`,
            //   Price: "",
            //   Refund: "",
            //   Admin: "",
            //   "%": " ",
            //   "£": "",
            //   data: item,
            // });

            // l.push({
            //   id: `item-${index}-3`,
            //   Sells: `. `,
            //   Agreement: "",
            //   Price: "",
            //   Refund: "",
            //   Admin: "",
            //   "%": " ",
            //   "£": "",
            //   // data: item,
            // });
          });

          if (l && l[0]) {
            getPricingexception().then((pricingexceptionRes) => {
              if (pricingexceptionRes?.data && pricingexceptionRes?.data[0]) {
                l = l.map((a) => {
                  pricingexceptionRes.data.forEach((b) => {
                    if (a?.data?.id === b?.pricingid) {
                      constant.refundDD.forEach((c) => {
                        if (c?.refundid === b?.refundid) {
                          a.Refund = genTbTxtGreen(c?.label || "");
                          return;
                        }
                      });

                      constant.auAdminChargesDD.forEach((c) => {
                        if (c?.id === b?.poladmincosttype) {
                          a.Admin = genTbTxtGreen(c?.label);
                          return;
                        }
                      });

                      a["%"] = genTbTxtGreen(b?.poladmincostcent);
                      a["£"] = b?.poladmincostamt
                        ? formatAmountForTb2(b?.poladmincostamt)
                        : "";
                      a["Price"] = formatAmountForTb2(b?.newprice);
                      a["Sells"] = genTbTxtGreen("Yes");
                      a.data.pricingexceptiodata = b;
                    }
                  });
                  return a;
                });
              }
            });
          }

          setList(l);
        } else {
          setList([]);
        }
      } else {
        toaster.create({
          title: res?.message || "error",
          type: "error",
        });
      }
    });
  };

  useEffect(() => {
    getList({ action: "useEffect" });
    getRefundDD({ action: "useEffect" });
    getChangeAdminchargeDD({ action: "useEffect" });
    // getPricingexception();
    console.log("itemData", itemData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flex flex={1} overflow={"hidden"} direction={"column"} p={"2rem"}>
      <Header
        label={`Pricing & Refunds${
          itemData?.item?.dealer ? " - " + itemData?.item?.dealer : ""
        }`}
        isLoading={isLoading}
      />
      <TableList
        type={"simple"}
        selectedItem={selectedItem}
        onSelect={onSelect}
        headers={headers}
        items={list}
      />
      <SimpleGrid
        columns={ismobile ? 1 : 2}
        // maxWidth={"25rem"}
        columnGap="2rem"
        rowGap="1rem"
        mt={"1rem"}
      >
        <InputComp
          type={"dropdown"}
          label={"Admin Charge"}
          items={adminchargeDD}
          onChange={onChangeAdminchargeDD}
          disabled={!selectedItem}
        />
        <>
          {adminchargeItem?.id === 1 ? (
            <InputComp
              label={"Percent"}
              value={adminChargePer}
              onChange={setAdminChargePer}
              type={"number"}
            />
          ) : null}

          {adminchargeItem?.id === 2 ? (
            <InputComp
              label={"Amount"}
              value={adminChargeAmount}
              onChange={setAdminChargeAmount}
              type={"number"}
            />
          ) : null}
        </>

        <InputComp
          type={"dropdown"}
          label={"Refund"}
          items={refundDD}
          onChange={onChangeRefundDD}
          disabled={!selectedItem}
        />
        <InputComp
          type={"number"}
          label={"Price"}
          disabled={!selectedItem}
          value={newprice}
          onChange={setNewprice}
        />
        {/* <InputComp type={"number"} label={"Percent"} disabled={!selectedItem} /> */}
      </SimpleGrid>

      <Flex wrap={"wrap"} justify={"end"} gap={"1rem"} mt={"1rem"}>
        <ButtonComp
          label="Update"
          disabled={!selectedItem}
          // w={"12rem"}
          // variant="outline"
          onClick={onUpdate}
        />
        {/* Update */}
        {/* </Button> */}
        <ButtonComp
          label="Save"
          onClick={onSubmit}
          // disabled={!selectedItem}
          keyname="save"
          disabled={isLoading}
        />
      </Flex>
    </Flex>
  );
}

export default PricingView;
